import { render } from "./FileManagerCompliance.vue?vue&type=template&id=2dc01d09&scoped=true"
import script from "./FileManagerCompliance.vue?vue&type=script&lang=js"
export * from "./FileManagerCompliance.vue?vue&type=script&lang=js"

import "./FileManagerCompliance.vue?vue&type=style&index=0&id=2dc01d09&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc01d09"]])

export default __exports__